/**
 * 결과 원문 뷰 — N개 블록 일반화(@spec:2026-09-29-처방검토-판정기록-조회화면).
 *
 * 테스트 패널은 요청·응답 2블록, 판정 기록 상세는 요청·룰·결과 3블록을 넘긴다. 각 블록은
 * <pre> + JSON.stringify(복사 버튼). emptyText가 있으면 그 문구를 보여 주고 복사를 비활성화한다
 * (테스트 패널의 status:null "응답 없음" 보존). 문법 강조 라이브러리는 쓰지 않는다.
 * testid·copyTestId는 호출부가 준다 — 기존 e2e의 dose-raw-request·dose-raw-response·
 * dose-raw-copy-request를 그대로 쓰기 위해(현황 6).
 */
import React from "react";
import Button from "components/atoms/Button";
import { ToastManager } from "components/organisms/CommonUI/ToastPopup/ToastManager";
import { log, LogLevel } from "utils/LogUtil";
import { RawWrap, RawBlock, RawHead, Pre } from "./style";

export interface RawBlockSpec {
  key: string;
  title: string;
  value: unknown;
  /** 있으면 JSON 대신 이 문구를 보여 주고 복사를 비활성화한다(예: "응답 없음"). */
  emptyText?: string;
  testId?: string;
  copyTestId?: string;
}

interface Props {
  blocks: RawBlockSpec[];
}

const pretty = (v: unknown): string => {
  try {
    return JSON.stringify(v, null, 2);
  } catch {
    return String(v);
  }
};

const copy = async (text: string) => {
  try {
    await navigator.clipboard.writeText(text);
    ToastManager.show({ content: "복사했습니다" });
  } catch (e) {
    log(LogLevel.ERROR, "원문 복사 실패:", e);
  }
};

const RawView: React.FC<Props> = ({ blocks }) => {
  return (
    <RawWrap>
      {blocks.map((b) => {
        const isEmpty = b.emptyText != null;
        const text = isEmpty ? (b.emptyText as string) : pretty(b.value);
        return (
          <RawBlock key={b.key}>
            <RawHead>
              <span>{b.title}</span>
              <Button
                buttonType="button"
                type="Text"
                size="XSmall"
                variant="Outlined"
                color="Secondary"
                disabled={isEmpty}
                onClick={() => copy(text)}
                data-testid={b.copyTestId}
              >
                복사
              </Button>
            </RawHead>
            <Pre data-testid={b.testId}>{text}</Pre>
          </RawBlock>
        );
      })}
    </RawWrap>
  );
};

export default RawView;
